export const BINGO_COLUMNS = ["DATA", "WORK", "THE SYSTEM", "WASTELAND", "ANARCHY"];

export const BINGO_SQUARES = [
  { title: "Applicant Profile Corrupted", detail: "Data mismatch throws a fatal error." },
  { title: "Underpaid Micro-Task Completed", detail: "Earn +5 meaningless EXP." },
  { title: "FREE SPACE", detail: "System Optimization Active — all hail the DOLOS AI.", free: true },
  { title: "Acid Rain Korrosive Alert", detail: "Shield your fragile crops." },
  { title: "Whispers of Resistance", detail: "Hear tales of the old world." },
  { title: "OJO Gives Passive-Aggressive Advice", detail: "Performance coach is watching." },
  { title: "Forced Job Reallocation", detail: "You are now a Trench Digger." },
  { title: "Out of Memory / Out of Time", detail: "The countdown timer hits 0." },
  { title: "Scavenged Pre-War Tech", detail: "Found a working USB drive in the mud." },
  { title: "Bypassing Corporate Firewall", detail: "Helping an applicant slip through cracks." },
  { title: "Gauetia Economy Plummets", detail: "Mass unemployment hits peak levels." },
  { title: "Mandatory Overtime Approved", detail: "Productivity up, sanity down." },
  { title: "Drag & Drop Card Chaos", detail: "Sorting applicants into training bins." },
  { title: "Vertical Farm Platform Built", detail: "Stacking survival higher." },
  { title: "The Unperson", detail: "An applicant's file is entirely wiped." },
  { title: "AI Predicts Your Exact Demise", detail: "According to data, you quit in 3 days." },
  { title: "Coffee Machine Emits Toxic Steam", detail: "Do not ingest." },
  { title: "Colleague Marie Passes a Note", detail: "Meets in the shadow of the server rack." },
  { title: "Standoff with a Wasteland Mutant", detail: "Your drone handles it." },
  { title: "Getting Fired by the Algorithm", detail: "Zero EXP remaining — system ejection." },
  { title: "Error Code 404:", detail: "Future Not Found." },
  { title: "Sorting Low-Priority Piles", detail: "Buried under endless student data." },
  { title: "The Grand Compliance Check", detail: "Did you maximize corporate efficiency?" },
  { title: "Scrap Metal Harvested", detail: "Even junk has a purpose." },
  { title: "The Secret \"Eden\" Mark Discovered", detail: "Uncover pre-apocalypse truth." },
];
